const DEFAULT_BATCH_SIZE = 10;

export const runInBatches = async (items, batchSize, fn) => {
  const results = [];
  const size = batchSize || DEFAULT_BATCH_SIZE;

  for (let i = 0; i < items.length; i += size) {
    const batch = items.slice(i, i + size);
    const batchResults = await Promise.all(batch.map(fn));
    results.push(...batchResults);
  }

  return results;
};

export default runInBatches;
